export default __webpack_public_path__ + "static/media/gilroy-semibold-webfont.2b066ef1.woff2";